/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/structural_template/canvas_templates_data" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdStructuralTemplateCanvasTemplatesData } from "./constants";
import type {
  EngagementAppGroupIdStructuralTemplateCanvasTemplatesDataParams,
  CanvasTemplatesResult,
} from "./types";

export const getDataTableCanvasTemplates = reactQueryTableFetcherAdapter(
  engagementAppGroupIdStructuralTemplateCanvasTemplatesData,
  (
    signal: AbortSignal,
    {
      appGroupId,
      preset,
      query = {},
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
      agentic,
    }: EngagementAppGroupIdStructuralTemplateCanvasTemplatesDataParams
  ): Promise<CanvasTemplatesResult> => {
    const { created_start_date, created_end_date, last_edited_start_date, last_edited_end_date, ...strippedQuery } =
      query;

    return fetch(
      `/engagement/${appGroupId}/structural_template/canvas_templates_data`,
      "GET",
      {
        preset: preset ? "1" : undefined,
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        agentic,
        query: serializeQueryObjects({
          ...strippedQuery,
          ...formatCreatedAtTime(created_start_date, created_end_date),
          ...formatLastEditedTime(last_edited_start_date, last_edited_end_date),
        }),
      },
      { signal }
    );
  }
);

// Override query to backend so date fields are nested in "created_at"
const formatCreatedAtTime = (createdStartDate?: number, createdEndDate?: number) => {
  if (createdStartDate && createdEndDate) {
    return {
      created: {
        start_date: createdStartDate,
        end_date: createdEndDate,
      },
    };
  }
};

// Override query to backend so date fields are nested in "edited"
const formatLastEditedTime = (lastEditedStartDate?: number, lastEditedEndDate?: number) => {
  if (lastEditedStartDate && lastEditedEndDate) {
    return {
      edited: {
        start_date: lastEditedStartDate,
        end_date: lastEditedEndDate,
      },
    };
  }
};
